import { useUpdateAtom } from 'jotai/utils';
import { forwardRef, useEffect, useState } from 'react';
import SearchSection from '../SearchSection';
import MainCategories from './MainCategories';
import SubCategories from './SubCategories';
import useSearchFilter from 'components/search/hooks/useSearchFilter';
import { add_category_atom, remove_category_atom, set_category_atom } from 'components/search/store/searchSheet';
import { CategoryFilterItem } from 'util/search_utils';

interface Props {
  onCategoryFocus: () => void;
}

/**
 * 검색필터 - 카테고리 영역
 * @component
 */
const Category = forwardRef<HTMLElement, Props>(({ onCategoryFocus }, ref) => {
  const [is_selected, setIsSelected] = useState(false);
  const { category_list } = useSearchFilter();
  const addCategory = useUpdateAtom(add_category_atom);
  const setCategory = useUpdateAtom(set_category_atom);
  const removeCategory = useUpdateAtom(remove_category_atom);

  const selected_sub_category = category_list.find((category) => {
    return category.selected || category.sub_category_list.some((sub_category) => sub_category.selected);
  });

  const is_selected_category = category_list.some((item) => {
    return item.selected || item.sub_category_list.some((si) => si.selected);
  });

  const handleAddMainCategory = async (category: CategoryFilterItem) => {
    setIsSelected(true);
    addCategory(category);
  };

  useEffect(() => {
    if (is_selected_category && is_selected) {
      setIsSelected(false);
      onCategoryFocus();
    }
  }, [is_selected_category, is_selected, onCategoryFocus]);

  if (category_list.length <= 0) {
    return null;
  }

  return (
    <SearchSection title='카테고리' ref={ref}>
      {!is_selected_category && <MainCategories category_list={category_list} onAddCategory={handleAddMainCategory} />}
      {is_selected_category && (
        <SubCategories category={selected_sub_category} onSetCategory={setCategory} onRemoveCategory={removeCategory} />
      )}
    </SearchSection>
  );
});

export default Category;
